/**
 * Server-side auth failures on a perspective subscription. The socket carries
 * the ID token it was opened with; once that token is stale every new
 * subscription on it is rejected with one of these (see
 * perspective_server user_from_info / IdToken.token_and_customer_id_to_user
 * and IdToken.verify_id_token).
 *
 * Deliberately narrow: recovering costs an app-wide socket reopen, so only
 * the server's own auth messages qualify. Generic words like "unauthorized"
 * or "forbidden" can appear in arbitrary transform error text and are NOT
 * matched.
 *
 * Kept free of imports so UI code can classify an error without pulling in
 * the Apollo/graphql-ws client.
 */
const AUTH_ERROR_PATTERNS = [
  "user not found",
  "no token found",
  "customer id not found",
  "token verification failed",
  "signature has expired",
];

export const isPerspectiveAuthError = (message: unknown): boolean => {
  const text = String(message ?? "").toLowerCase();
  return AUTH_ERROR_PATTERNS.some((p) => text.includes(p));
};
